import React from "react";
import { Alert, Box, Button, Stack, Typography } from "@mui/material";

export default class ReportErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message: error?.message || "Unexpected render error",
    };
  }

  componentDidCatch(error, errorInfo) {
    // Keep console visibility for debugging without breaking UI.
    // eslint-disable-next-line no-console
    console.error("AppraisalsReport runtime error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <Box sx={{ p: 3 }}>
        <Stack spacing={1.5}>
          <Typography variant="h5" sx={{ fontWeight: 800 }}>
            Appraisals Report
          </Typography>
          <Alert severity="error">
            This page failed to render. Please reload and try again.
          </Alert>
          <Typography variant="body2" color="text.secondary">
            Error: {this.state.message}
          </Typography>
          <Box>
            <Button variant="contained" onClick={this.handleReload}>
              Reload Page
            </Button>
          </Box>
        </Stack>
      </Box>
    );
  }
}

